
import { Fulfillment, ShippingDistanceUnit, ShippingWeightUnit } from "./fulfillment.types";
import { ListingVariationPublic } from "./listings.types";
import { FulfillmentRefundInfo } from "./refund.types";
import { User } from "./user.types";

export type OrderStatusType = "initiated"
  | "pending"
  | "active"
  | "removed"
  | "suspended"
  | "review"
  | "error"
  | "archived"
  | "cart"
  | "abandoned"
  | "purchasing"
  | "purchased"
  | "fulfilling"
  | "fulfilled"
  | "refundedish"
  | "refunded"
  | "completed"

export const createBlankOrder = async (buyerUserId: string, buyerId: string): Promise<OrderPublic> => {
  const order: OrderPublic = {
    id: 'new',
    orderNumber: 0,
    statusId: 'cart',
    buyerId,
    buyerUserId,
    paymentProcessorId: 'stipe',
    subTotalAmount: undefined,
    orderItems_on_order: [],
    discounts_on_order: [],
    fulfillments_on_order: [],
    totalDiscountAmount: undefined,
    totalShippingAmount: undefined,
    totalTaxAmount: undefined,
    totalAmount:undefined
  }
  return order
}

export interface OrderTotals {
  subTotalAmount?: number
  totalDiscountAmount?: number
  totalShippingAmount?: number
  shippingTaxAmount?: number
  totalTaxAmount?: number
  totalAmount?: number
  totalFixedShippingAmount?: number
  commissionAmount?: number
}

export interface StripeOrderTotals extends OrderTotals {
  lineItems: StripeOrderLineItems[]
}

export interface StripeOrderLineItems {
  amount: number,
  tax_code: string,
  reference: string,
  quantity: number,
}

export interface OrderPublic extends OrderTotals {
  id?: string;
  orderNumber: number;
  buyerId: string;
  buyerUserId?: string;
  interactionId?: string
  orderItems_on_order: OrderItem[]
  discounts_on_order: Discount[]
  fulfillments_on_order: Fulfillment[]
  orderItems_by_location?: CartItemsGrouped;
  orderItems_by_fulfillment?: CartItemsGrouped;
  orderItems_by_refund?: CartItemsGrouped;
  refunds_by_fulfillment?: { [fulfillmentId: string]: FulfillmentRefundInfo }
  paymentProcessorId?: string
  paymentTransactionId?: string
  customerComments?: string
  orderPlaced?: number
  statusId: OrderStatusType;
  nextStatusActionDue?: number
  createdAt?: number
}

export interface Cart extends OrderPublic {
  orderItems_on_order: OrderItem[]
}

export interface OrderOrFulfillment extends OrderPublic {
  marketPlaceCommission?: number;
  shippingCharged?: number,
  isFulfillment?: boolean;
  totalFixedShippingAmount?: number;
  taxCalculationId?: string;
}

export interface AddItemsToShippingRateVariables {
  orderId: string;
  orderItemIds: string[];
  shippoRateId: string;
}

export interface AddItemToCartVariables {
  quantity: number,
  fulfilledToLocationId: string,
  fulfilledByLocationId: string,
  orderId: string,
  listingVariationId: string,
}

export interface ShippingRateOption {
  amount: number,
  durationTerms: string,
  objectId: string,
  provider: string,
  providerImage200: string // https://cdn2.goshippo.com/providers/200/USPS.png,
  servicelevel: {
    name: string // Priority Mail Express,
  },
}

export type ShippableBase = {
  id: string;
  height: number;
  length: number;
  width: number;
  weight: number;
  distanceUnit: ShippingDistanceUnit;
  weightUnit: ShippingWeightUnit;
}

export interface Shippable extends ShippableBase {
  rateProviderName?: string;
  rateProviderImg?: string;
  rateName?: string;
  rateMsg?: string;
  shippingProcessorParcelId?: string;
}

export interface ShippableReporting {
  rateId?: string;
  rateCharged?: number;
  rateCost?: number;
}

export interface CartItemsGrouped {[groupId: string]: OrderItem[]}
export interface GetIntentReturn { clientSecret: string, paymentIntentId: string, tax: any | undefined } // Stripe.Tax.Calculation

export interface OrderItem extends Shippable, ShippableReporting {
  id: string
  orderId: string 
  refundId?: string
  listingVariation: ListingVariationPublic
  quantity: number
  totalTax?: number
  fulfillmentId: string
  parcelId?: string
  fulfilledToLocationId: string
  fulfilledByLocationId: string
  pricePerItemAtTimeOfOrder: number
  totalCostAtTimeOfOrder: number
  isDigitalDownload: boolean;
  fixedShippingCost?: number
  createdAt: number
}

export interface Discount {
  locationId: string
  code: string
  description: string
  discountPercent: number;
  maxUses?: number
  uses: number
  validFrom: number
  validTo: number
  reusableAmount: number
  fulfillments_on_discount: Fulfillment[]
  statusId: string
  createdAt?: number
  createdBy?: User
  updatedAt?: number
  updatedBy?: User
  updatedById?: string

}

export interface OptionData {
  fulfillment: Fulfillment, 
  order: OrderPublic, 
  restockItems?: boolean
}

